import { RegularButton, Modal } from 'fronton-react'
import { FC } from "react";
import './modalClasses.scss'

export interface ApproveConfirmModalProps {
    open: boolean,
    onClose: () => void,
    onApprove: () => void,
}

export const ApproveConfirmModal:FC<ApproveConfirmModalProps> = ({open, onClose, onApprove}) => {
    return (
        <Modal
                size="s"
                key="approveConfirmModal"
                show={open}
                className="add-calendar-modal"
                closeButton={false}
                onClose={onClose}
                overlayType="medium"
            >
                <div className="modal-content">
                    <div className="modal-content-body">
                        Вы уверены, что хотите утвердить календарь недоступности? После утверждения
                        календарь невозможно будет изменить
                    </div>
                    <div className="modal-content-actions">
                        <RegularButton
                            key="submit"
                            size="s"
                            variant="primary"
                            className="modal-content-btn"
                            onClick={onApprove}
                        >
                            Да
                        </RegularButton>
                        <RegularButton
                            key=""
                            size="s"
                            variant="primary"
                            className="modal-content-btn"
                            onClick={onClose}
                        >
                            Нет
                        </RegularButton>
                    </div>
                </div>
            </Modal>
    )
}